import React, { useContext, useState } from 'react';

import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';

import ArrowRightIcon from '@mui/icons-material/East';

import { LoadingButton } from '../../Loaders';

import { string, ValidationError } from 'yup';

import Axios from '../../../Assets/Axios/Axios';

import ToastContext from '../../../Context/ToastContext';

import { TypoPoppins } from '../../Typo';

import { FindUserByEmail, SendCode } from '../../../Server/Query';

import { FORM_STEP } from './index';
import { EMAIL_TEMPLATES } from '../../../Constant/Enums';

function Email({ updateFormStep, otpReferenceId, email, onChange }) {
  const { showToastMessage } = useContext(ToastContext);

  const [emailError, setEmailError] = useState(null);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

  async function handleSubmit(event) {
    try {
      event.preventDefault();
      setIsSubmitDisabled(true);
      setEmailError(null);

      const validatedEmail = await schema.validate(email);

      //check email associated with an account
      const { data, errors } = await Axios(FindUserByEmail({ email: validatedEmail }));

      if (errors) {
        showToastMessage(
          'Oops! Something went wrong!,While trying to find your account.'
        );
        return undefined;
      }

      if (data.EventBooker === null) {
        setEmailError('The email you entered isn’t connected to an account.');
        return undefined;
      }

      //send otp
      const result = await sendVerificationCode(validatedEmail);
      if (result.error) throw new Error();

      otpReferenceId.current = result.data.referenceId;
      updateFormStep({ payload: FORM_STEP.VERIFY_CODE });
    } catch (error) {
      if (error instanceof ValidationError) {
        setEmailError(error.message);
        return undefined;
      }
      showToastMessage('Something went Wrong');
    } finally {
      setIsSubmitDisabled(false);
    }
  }

  return (
    <Box
      component='form'
      px={{ xs: 2, md: 3 }}
      py={{ xs: 3, md: 6 }}
      onSubmit={handleSubmit}
    >
      <TypoPoppins
        textAlign='center'
        fontWeight={600}
        variant='h6'
        variantMapping={{ h6: 'h1' }}
      >
        Forgot Password
      </TypoPoppins>

      <TypoPoppins textAlign='center' color='text.secondary'>
        Please enter your email address to <br />
        receive a verification code
      </TypoPoppins>

      <Stack
        gap={1}
        mt={4}
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'center', sm: 'flex-start' }}
      >
        <TextField
          id='email'
          autoComplete='email'
          value={email}
          onChange={onChange}
          inputProps={{ spellCheck: false }}
          fullWidth
          helperText={emailError}
          error={Boolean(emailError)}
        />

        <LoadingButton
          aria-label='submit email'
          isLoading={isSubmitDisabled}
          type='submit'
          color='blue'
          size='large'
        >
          <ArrowRightIcon htmlColor='white' />
        </LoadingButton>
      </Stack>
    </Box>
  );
}
const schema = string().required().email().label('Email').lowercase();

async function sendVerificationCode(email) {
  const query = SendCode({ email, template: EMAIL_TEMPLATES.PASSWORD_RESET });
  const { errors, data } = await Axios(query);

  if (errors) return { error: true, data: null };

  return { error: false, data: { referenceId: data.SendCode.referenceId } };
}

export default Email;
